/* istanbul ignore file */
import React from "react";
import { HoverModeProvider } from "@react-md/utils";
import { DEFAULT_TOOLTIP_DELAY } from "./constants";
/**
 * This component is used so that tooltips can gain the "hover mode"
 * functionality in that once a tooltip has become visible by hover, all other
 * tooltips will become visible immediately until 3 seconds have passed.
 *
 * @deprecated \@since 2.8.0 Use the {@link HoverModeProvider} instead.
 */
export function TooltipHoverModeConfig(_a) {
    var _b = _a.defaultDelay, defaultDelay = _b === void 0 ? DEFAULT_TOOLTIP_DELAY : _b, _c = _a.delayTimeout, delayTimeout = _c === void 0 ? DEFAULT_TOOLTIP_DELAY : _c, _d = _a.enabled, enabled = _d === void 0 ? true : _d, children = _a.children;
    return (React.createElement(HoverModeProvider, { disabled: !enabled, defaultVisibleInTime: defaultDelay, deactivateTime: delayTimeout }, children));
}
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        TooltipHoverModeConfig.propTypes = {
            enabled: PropTypes.bool,
            delayTimeout: PropTypes.number,
            defaultDelay: PropTypes.number,
            children: PropTypes.node.isRequired,
        };
    }
    catch (e) { }
}
//# sourceMappingURL=TooltipHoverModeConfig.js.map